<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import { postReq } from 'src/services/http';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';

	export let device: Device;

	const id = device.id,
		save = async () => {
			const newCheckedValue = !checked;
			const exclude_event_log = newCheckedValue;

			const res = await postReq('interface/device/set_cloud_options', {
				id: device.id,
				set: 'exclude_event_log',
				val: exclude_event_log,
			});

			if (res.isok) {
				if (!device.cloud_options) {
					device.cloud_options = {};
				}
				device.cloud_options.exclude_event_log = exclude_event_log;
				devices.update(device);
				checked = newCheckedValue;
				initCheckedState = exclude_event_log;
			}
			const toastTexts = {
				success: $format('event_log_scc_toast', {
					default: 'Event log exclusion settings changed.',
				}),
				danger: $format('event_log_err_toast', {
					default: 'Failed to change event log exclusion settings!',
				}),
			};
			onSettingsResponse(res, device, toastTexts);
		};

	let checked =
			$devices[id]?.cloud_options?.exclude_event_log || $devices[id]?.exclude_event_log || false,
		initCheckedState = checked;
</script>

<Toggle {checked} size="m" on:click={save} id="toggle-66wv9cg">
	{$format('toggle_exclude_from_global_activity_log', {
		default: 'Disable event log reports for this device.',
	})}
</Toggle>
